import { ReportTranslationKeys } from 'intl/keys';
import { TranslationKey } from 'intl/types/translationKey';
import { ImageDisplayStyle } from 'shared/domain/report/types/model/common';

const IMAGE_DISPLAY_STYLE_LABEL_KEYS: Record<ImageDisplayStyle, TranslationKey> = {
  [ImageDisplayStyle.miniatures]: ReportTranslationKeys.displayStyleMiniatures,
  [ImageDisplayStyle.fullPage]: ReportTranslationKeys.displayStyleFullA4,
  [ImageDisplayStyle.list]: ReportTranslationKeys.displayStyleList,
};

export function imageDisplayStyleLabelKey(
  style: ImageDisplayStyle
): TranslationKey {
  return IMAGE_DISPLAY_STYLE_LABEL_KEYS[style];
}
